export default {
  authjson: function (v) {
    // const arr = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"];
    const arr = [
      "1", "1-1", "1-2", "1-3", "1-4",
      "2", "2-1", "2-2", "2-3", "2-4", "2-5", "2-6",
      "3", "3-1", "3-2", "3-3", "3-4", "3-5", "3-6", "3-7",
      "4", "4-1", "4-2", "4-3", "4-4", "4-5", "4-6", "4-7", "4-8",
      "5",
      "6",
      "7",
      "8",
      "9", "9-1", "9-2", "9-3", "9-4", "9-5", "9-6", "9-7", "9-8", "9-9", "9-10", "9-11", "9-12", "9-13", "9-14", "9-15", "9-16", "9-17", "9-18", "9-19",
      "10",
      "11", "11-1", "11-2", "11-3", "11-4", "11-5", "11-6", "11-7", "11-8", "11-9", "11-10",
      "12", "12-1", "12-2", "12-3", "12-4", "12-5",
      "13", "13-1", "13-2", "13-3", "13-4", "13-5", "13-6"
    ];


    let authInfo = sessionStorage.getItem("authjson") || arr;
    // console.log(authInfo);

    if (!authInfo || authInfo == "undefined") {
      authInfo = arr;
    }
    authInfo = JSON.parse(authInfo);
    // let arr2 = eval('(' + authInfo + ')');
    // console.log(arr2.includes("2"))

    if (authInfo && authInfo.length) {
      for (let i = 0; i < v.length; i++) {
        if (authInfo.includes(v[i])) {
          return true;
        }
      }
    } else {
      return false;
    }
  },
};